enum NewYearGachaGift {
    AutoLayoutGingerbreadMan = "autoLayoutGingerbreadMan",
    PixelPerfectCandyCane = "pixelPerfectCandyCane",
    HolidayEmergencyKit = "holidayEmergencyKit",
    ZoClaus = "zoClaus",
    BranOrnamentEngineer = "branOrnamentEngineer",
    TipsyTreeJan = "tipsyTreeJan",
    AttemptedTreeTopper = "attemptedTreeTopper",
    StudioApartmentInNorthPole = "studioApartmentInNorthPole",
    VisitorFromPier39 = "visitorFromPier39",
    NorthPolesNewDesignLead = "northPolesNewDesignLead",
    TipsyOrnaments = "tipsyOrnaments",
    WallpaperForest = "wallpaperForest",
    WallpaperTipsyTrio = "wallpaperTipsyTrio",
    WallpaperBeanie = "wallpaperBeanie",
    WallpaperGlobe = "wallpaperGlobe",
    WallpaperAngel = "wallpaperAngel",
    WallpaperUglySweater = "wallpaperUglySweater",
    WallpaperWatercolor = "wallpaperWatercolor",
    SnowButton = "snowButton",
}

enum NewYearGachaGiftRarity {
    Common = "common",
    Rare = "rare"
}

export default NewYearGachaGift;

export { NewYearGachaGiftRarity };
